import * as React from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from './Accordion'

import Box from '@mui/material/Box'
import ExpandMore from '@mui/icons-material/ExpandMore'

type Props = {
  children: React.ReactNode
}

export function Footer(props: Props) {
  const { children } = props

  return (
    <Box mx={-2} mt={1}>
      <Accordion
        TransitionProps={{ unmountOnExit: true }}
        style={{ backgroundColor: 'inherit' }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          Related Service Locations
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </Box>
  )
}
